import Vue from "vue";
/*import { ref } from 'vue'*/
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';

Vue.component("modifications-parent", {
    //setup() {
    //    const viewer = ref(null);
    //    return {
    //        viewer
    //    }
    //},
    props: ["parents", "ownerType"],
    computed: {
        treeData: function () {
            return new Tree(this.parents);
        },
        coverageExclusionTooltipLabel: function () {
            return window.labels.coverageExclusionTooltip;
        }
    },    
    methods: {
        showModifications(model) {
            const self = this;

            if (model != null) {
                if (model.updated || model.deleted || model.added) {
                    self.$nextTick(() => {
                        self.$refs.viewer.initialize(model.principalId);
                    });
                }
            }
        }
    },
    template: `
        <div>
            <vue-tree-list 
                :model="treeData"
                v-bind:default-expanded="false">
                <template v-slot:leafNameDisplay="props">                    
                    <div :id="ownerType + '-' + props.model.controlId" class="modification-row" @click="showModifications(props.model)">
                        <i v-if="props.model.excluded" class="fas fa-ban mt-1 has-text-danger mr-2" :title="coverageExclusionTooltipLabel"></i>
                        <div class="modification-row-reference-number pr-2">
                            <modification-matcher :old="props.model.oldReferenceNumber" :latest="props.model.referenceNumber" :updated="props.model.updated" :deleted="props.model.deleted" :added="props.model.added" :showIcon="false" :useDiffMatch="false" :applyInlineStyle="false"></modification-matcher>
                        </div>
					    <div class="modification-row-display-name">
                            <modification-matcher :old="props.model.oldText" :latest="props.model.text" :updated="props.model.updated" :deleted="props.model.deleted" :added="props.model.added" :showIcon="true" :useDiffMatch="true" :applyInlineStyle="true"></modification-matcher>                                
                        </div> 
                    </div>
                    <div class="modification-row" v-if="props.model.items != null && props.model.items.length > 0">
                        <modifications-child :child="props.model" :key="props.model.id"></modifications-child>
                    </div>
                </template>                    
                <template v-slot:treeNodeIcon="props">
                    <span class="icon">
                        <i v-if="props.model.children && props.model.children.length > 0" class="fa fa-sitemap"></i>
                        <i v-else class="fa fa-fw"></i>                        
                    </span>
                </template>
            </vue-tree-list>                
            <modification-viewer ref="viewer" :historyType="ownerType"></modification-viewer> 
        </div>
	`
});